import { render, staticRenderFns } from "./bc-chart.vue?vue&type=template&id=1770d6f5&"
import script from "./bc-chart.vue?vue&type=script&lang=ts&"
export * from "./bc-chart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports